import { render, staticRenderFns } from "./OrderDetailView.vue?vue&type=template&id=e537cd3c&"
import script from "./OrderDetailView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports